import React, { useState, useEffect, useRef } from 'react';
import { Heart, MessageCircle, Eye, TrendingUp, Flame, Award, Users, Clock, ChevronUp, ChevronDown, Share2, Bookmark, Filter, Search, Sparkles, Zap, Star, Trophy, Gift, Bell, Plus, X } from 'lucide-react';
export const UserLevelCard = ({ stats, isAuthenticated }) => {
  console.log('sytatsts', stats)
  // Show login prompt if user is not authenticated
  if (!isAuthenticated) {
    return (
      <div style={{
        background: 'linear-gradient(135deg, #333 0%, #444 100%)',
        color: 'white',
        padding: '24px',
        borderRadius: '20px',
        marginBottom: '24px',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '100px',
          height: '100px',
          background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
          borderRadius: '50%',
          transform: 'translate(30px, -30px)'
        }} />
        
        <div style={{
          textAlign: 'center',
          padding: '20px 0',
          position: 'relative',
          zIndex: 1
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px auto',
            border: '3px dashed rgba(255, 255, 255, 0.3)'
          }}>
            <div style={{
              fontSize: '32px',
              color: 'rgba(255, 255, 255, 0.5)'
            }}>
              ?
            </div>
          </div>
          
          <h3 style={{
            margin: '0 0 8px 0',
            fontSize: '18px',
            fontWeight: '700',
            color: 'white'
          }}>
            Login to Track Progress
          </h3>
          
          <p style={{
            margin: '0 0 20px 0',
            fontSize: '14px',
            color: 'rgba(255, 255, 255, 0.8)',
            lineHeight: '1.4'
          }}>
            Sign in to track your level, XP, and stats
          </p>
          
          <button
            onClick={() => window.location.href = '/login'} // Adjust to your login route
            style={{
              padding: '12px 24px',
              background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '16px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(16, 185, 129, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)';
            }}
          >
            Sign In
          </button>
        </div>
      </div>
    );
  }

  // Loading state
  if (!stats) {
    return (
      <div style={{
        background: 'linear-gradient(135deg, #333 0%, #444 100%)',
        color: 'white',
        padding: '24px',
        borderRadius: '20px',
        marginBottom: '24px'
      }}>
        <div style={{ textAlign: 'center', color: '#888' }}>
          Loading stats...
        </div>
      </div>
    );
  }

  // Calculate progress percentage, handling different property names
  const nextLevelThreshold = stats.next_level_threshold || stats.get_next_level_threshold || stats.nextLevelXp || 100;
  const progressPercentage = Math.min((stats.xp / nextLevelThreshold) * 100, 100);

  return (
    <div style={{
      background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
      color: 'white',
      padding: '24px',
      borderRadius: '20px',
      marginBottom: '24px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: '100px',
        height: '100px',
        background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
        borderRadius: '50%',
        transform: 'translate(30px, -30px)'
      }} />
      
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '20px',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div style={{
            width: '60px',
            height: '60px',
            background: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
            fontWeight: 'bold'
          }}>
            {stats.level || 1}
          </div>
          <div>
            <h3 style={{ margin: 0, fontWeight: '700', fontSize: '18px' }}>Level {stats.level || 1}</h3>
            <p style={{ margin: 0, color: 'rgba(255, 255, 255, 0.8)', fontSize: '14px' }}>
              {stats.reputation || 0} reputation • {(stats.posts || 0) + (stats.threads || 0)} posts
            </p>
          </div>
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
          padding: '8px 12px',
          borderRadius: '16px',
          fontSize: '12px',
          fontWeight: '600'
        }}>
          <Flame size={14} />
          {stats.streak || 0} day streak
        </div>
      </div>
      
      <div style={{ marginBottom: '16px', position: 'relative', zIndex: 1 }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: '14px',
          marginBottom: '8px',
          color: 'rgba(255, 255, 255, 0.9)'
        }}>
          <span>Progress to Level {(stats.level || 1) + 1}</span>
          <span>{stats.xp || 0}/{nextLevelThreshold} XP</span>
        </div>
        <div style={{
          width: '100%',
          height: '8px',
          background: 'rgba(255, 255, 255, 0.2)',
          borderRadius: '4px',
          overflow: 'hidden'
        }}>
          <div style={{
            width: `${progressPercentage}%`,
            height: '100%',
            background: 'linear-gradient(90deg, #fbbf24 0%, #f59e0b 100%)',
            borderRadius: '4px',
            transition: 'width 0.8s cubic-bezier(0.4, 0, 0.2, 1)'
          }} />
        </div>
      </div>
      
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '6px',
        position: 'relative',
        zIndex: 1
      }}>
        {(stats.badges || []).map((badge, index) => (
          <span key={index} style={{
            fontSize: '11px',
            background: 'rgba(255, 255, 255, 0.2)',
            padding: '4px 8px',
            borderRadius: '12px',
            fontWeight: '500'
          }}>
            {badge}
          </span>
        ))}
      </div>
    </div>
  );
};